export enum StatusCode {
  RUNNING = 'RUN',
  ERROR = 'ERR',
  ACTIVE = 'ACT',
  INACTIVE = 'INA',
  ONLINE = 'ONL',
  OFFLINE = 'OFF'
}

export const StatusCodeLabels = {
  [StatusCode.RUNNING]: 'Running',
  [StatusCode.ERROR]: 'Error',
  [StatusCode.ACTIVE]: 'HOẠT ĐỘNG',
  [StatusCode.INACTIVE]: 'HẾT HẠN',
  [StatusCode.ONLINE]: 'Online',
  [StatusCode.OFFLINE]: 'Offline',
};
